import React, { useEffect, useState } from "react";
import "./App.css";
import { TrackerLandingPage } from "./performance-tracker-template/tracker-landing-page";
import { LoginPage } from "./pages/login";
import { AboutPage } from "./pages/about";
import { NavigationBar } from "./navigation-bar/navigation-bar";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { ReportingPage } from "./pages/reporting";
import { BenchmarkingPage } from "./pages/benchmarking";
import { DashboardPage } from "./pages/dashboard";
import { GuidePage } from "./pages/guide";
async function getData(url: string): Promise<any> {
  // Default options are marked with *
  const response = await fetch(url, {
    method: "GET", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, *same-origin, omit
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
  });
  if (response.ok) {
    return response.json(); // parses JSON response into native JavaScript objects
  } else {
    const text = (await response.text()).valueOf();
    throw new Error(text);
  }
}
function App() {
  const [about, setAbout] = useState<boolean>(true);
  const [loggedIn, setLoggedIn] = useState<UserDto>({id:-1, username:"not logged in", organisation:""});
  const [template, setTemplate] = React.useState<Template>({
    envTemplate: {},
    envTemplateStyles: {},
  });
  useEffect(()=>{
    if(loggedIn.id >=0){
      getData("https://greencityapi-new.absolarlab.com/api/Themes?cityCouncilId=0&user_id="+loggedIn.id.toString())
      .then((data: Template) => {
        setTemplate(data);
      })
      .catch((e) => {
        alert("error fetching template " + e);
      });
    }
    
  },[loggedIn])
  return (
    <Router>
      <div className="App">
        {loggedIn.id >=0 ? (
          <div>
            <div
              className="left_panel"
              style={{ height: "100vh", overflow: "auto" }}
            >
              <NavigationBar />
            </div>
            <Switch>
              <Route path="/home">
                <div className="main_panel">
                  <div id="central_panel">
                    <TrackerLandingPage userId={loggedIn.id} />
                  </div>
                </div>
              </Route>
              <Route path="/reporting">
                <div className="main_panel">
                  <div id="central_panel">
                    <ReportingPage organisation={loggedIn.organisation}/>
                  </div>
                </div>
              </Route>
              <Route path="/benchmarking">
                <div className="main_panel">
                  <div id="central_panel">
                    <BenchmarkingPage organisation={loggedIn.organisation} />
                  </div>
                </div>
              </Route>
              <Route path="/dashboard">
                <div className="dashboard_panel">
                  <div id="central_panel">
                    <DashboardPage organisation={loggedIn.organisation}/>
                  </div>
                </div>
              </Route>
              <Route path="/guide">
                <div className="dashboard_panel">
                  <div id="central_panel">
                    {Object.keys(template.envTemplate).length > 0 ?<GuidePage template={template}/>: "Loading guide"}
                  </div>
                </div>
              </Route>
              <Route
                path="/"
                render={() => <Redirect to="/home" />}
                exact={true}
              />
            </Switch>
          </div>
        ) : (
          <Switch>
            <Route path="/about">
              <div className="main_panel">
                <div id="central_panel">
                  <AboutPage setAbout={setAbout} />
                </div>
              </div>
            </Route>
            <Route path="/login">
              <div className="main_panel">
                <div id="central_panel">
                  <LoginPage setAbout={setAbout} setLoggedIn={setLoggedIn} />
                </div>
              </div>
            </Route>
            <Route
              path="/*"
              render={() => <Redirect to="/about" />}
              exact={true}
            />
          </Switch>
        )}
      </div>
    </Router>
  );
}

export default App;
